import React, { useEffect } from "react";
import { useAuth } from "wasp/client/auth";
import { useNavigate } from "react-router-dom";
import { BillingDashboard } from "../../../components/Admin/BillingDashboard";
// AppFrame removed: route-level layout wraps admin pages
import { DataTable, ChartAreaInteractive } from "../../components/Admin";
import type { DataTableColumn, BillingRecord } from "../../../types/admin";
import { Badge } from "../../components/ui/badge";
const billingData: BillingRecord[] = [
  {
    id: 1,
    header: "Cover page",
    type: "Cover page",
    status: "In Process",
    target: "18",
    limit: "5",
    reviewer: "Eddie Lake",
  },
  {
    id: 2,
    header: "Table of contents",
    type: "Table of contents",
    status: "Done",
    target: "29",
    limit: "24",
    reviewer: "Eddie Lake",
  },
  {
    id: 3,
    header: "Executive Summary",
    type: "Document",
    status: "Pending",
    target: "45",
    limit: "30",
    reviewer: "Sarah Johnson",
  },
];

const billingColumns: DataTableColumn<BillingRecord>[] = [
  {
    key: "header",
    label: "Item",
    sortable: true,
  },
  {
    key: "type",
    label: "Type",
    sortable: true,
  },
  {
    key: "status",
    label: "Status",
    sortable: true,
    render: (value) => {
      const status = value as string;
      const variant =
        status === "Done"
          ? "default"
          : status === "In Process"
            ? "secondary"
            : "outline";
      return <Badge variant={variant}>{status}</Badge>;
    },
  },
  {
    key: "target",
    label: "Target",
    sortable: true,
  },
  {
    key: "limit",
    label: "Limit",
    sortable: true,
  },
  {
    key: "reviewer",
    label: "Reviewer",
    sortable: true,
  },
];

export function AdminBilling() {
  const { data: user } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    if (user && !(user as any).isAdmin) navigate("/");
  }, [user]);
  return (
      <div className="space-y-6">
        <div className="mb-8">
          <h1 className="text-2xl font-bold text-martinique dark:text-white">
            Billing Administration
          </h1>
          <p className="mt-2 text-martinique/70 dark:text-white/70">
            Subscription management and billing analytics
          </p>
        </div>
        <ChartAreaInteractive
          config={{
            title: "Billing Analytics",
            description: "Revenue and subscription trends over time",
            data: [
              { date: "2025-10-01", revenue: 4200, subscriptions: 45 },
              { date: "2025-10-02", revenue: 4500, subscriptions: 48 },
              { date: "2025-10-03", revenue: 4300, subscriptions: 47 },
              { date: "2025-10-04", revenue: 4800, subscriptions: 51 },
              { date: "2025-10-05", revenue: 5100, subscriptions: 54 },
              { date: "2025-10-06", revenue: 4900, subscriptions: 52 },
              { date: "2025-10-07", revenue: 5200, subscriptions: 56 },
            ],
            dataKeys: ["revenue", "subscriptions"],
            colors: {
              revenue: "hsl(var(--chart-1))",
              subscriptions: "hsl(var(--chart-2))",
            },
          }}
        />

        <DataTable<BillingRecord>
          columns={billingColumns}
          data={billingData}
        />

        <BillingDashboard isAdmin={Boolean((user as any)?.isAdmin)} />
      </div>
  );
}

export default AdminBilling;
